import { buildReducer } from './buildReducer';

export default buildReducer({ fetchAction: 'NORMAL_RETIREMENT_ACCOUNTS_FETCHED' });
